<template>
  <v-container fluid>
    <v-layout wrap>
      <v-flex xs12 sm6>
        <v-btn
          depressed
          :outline="filter != 'all'"
          :color="filter == 'all' ? 'primary' : 'grey'"
          @click="filter = 'all'"
          class="ma-0 mr-1 mb-1"
          >{{ $t('All') }}</v-btn
        >
        <v-btn
          depressed
          :outline="filter != 'facebook'"
          :color="filter == 'facebook' ? 'primary' : 'grey'"
          @click="filter = 'facebook'"
          class="ma-0 mr-1 mb-1"
        >
          <i class="fab fa-facebook-square mr-1"></i>
          {{ $t('Facebook') }}
        </v-btn>
        <v-btn
          depressed
          :outline="filter != 'line'"
          :color="filter == 'line' ? 'primary' : 'grey'"
          @click="filter = 'line'"
          class="ma-0 mr-1 mb-1"
        >
          <i class="fab fa-line mr-1"></i>
          {{ $t('Line') }}
        </v-btn>
      </v-flex>
      <v-flex xs12 sm6 class="text-sm-right">
        <template v-if="loading">
          <v-btn :loading="true" color="grey" outline class="ma-0 mb-1"></v-btn>
        </template>
        <template v-else>
          <v-btn
            v-if="$store.getters.getPackage != 'premium'"
            outline
            v-tooltip.top="'Unlock to PREMIUM plan'"
            color="grey"
            class="ma-0 mb-1"
          >
            <i class="fas fa-file-export mr-1"></i>
            {{ $t('export') }}
            <v-premium-lock></v-premium-lock>
          </v-btn>
          <v-btn
            v-else-if="$store.getters.getPackage == 'premium'"
            @click="exportDashboard"
            color="grey"
            outline
            class="ma-0 mb-1"
          >
            <i class="fas fa-file-export mr-1"></i>
            {{ $t('export') }}
          </v-btn>
        </template>
      </v-flex>
    </v-layout>

    <date-filter v-model="selectedDate"></date-filter>

    <h3 class="title">{{ $t('Metrics') }}</h3>
    <active-user-by-date
      :loading="loadingActiveUserByDate"
      :selectedDate="selectedDate"
      :filter="filter"
      @onLoaded="onLoadingActiveUserByDate"
    ></active-user-by-date>
    <active-user-by-time
      :loading="loadingActiveUserByTime"
      :selectedDate="selectedDate"
      :filter="filter"
      @onLoaded="onLoadingActiveUserByTime"
    ></active-user-by-time>
  </v-container>
</template>

<script>
import ActiveUserByDate from './ActiveUserByDate.vue'
import ActiveUserByTime from './ActiveUserByTime.vue'
import DateFilter from './DateFilter'

import moment from 'moment'
import numeral from 'numeral'
export default {
  components: {
    ActiveUserByDate,
    ActiveUserByTime,
    DateFilter
  },
  computed: {
    loading: function() {
      return this.loadingActiveUserByDate && this.loadingActiveUserByTime
    }
  },
  data: function() {
    return {
      loadingActiveUserByDate: true,
      loadingActiveUserByTime: true,
      filter: 'all',
      selectedDate: {
        start: moment()
          .startOf('month')
          .format('YYYY-MM-DD'),
        end: moment()
          .endOf('month')
          .format('YYYY-MM-DD')
      },
      activeuserbydateSeries: [],
      activeuserbytimeSeries: []
    }
  },
  methods: {
    onLoadingActiveUserByDate: function(value) {
      this.loadingActiveUserByDate = value.loading
      if (value.data) {
        this.activeuserbydateSeries = value.data
      }
    },
    onLoadingActiveUserByTime: function(value) {
      this.loadingActiveUserByTime = value.loading
      if (value.data) {
        this.activeuserbytimeSeries = value.data
      }
    },
    exportDashboard: function() {
      let vm = this
      let csvContent = ''
      if (vm.loading) {
        return false
      }

      csvContent +=
        'From,"' +
        moment(vm.selectedDate.start).format('DD/MM/YYYY') +
        '",To,"' +
        moment(vm.selectedDate.end).format('DD/MM/YYYY') +
        '"\r\n'

      csvContent += 'Active Users by Date\r\n'
      csvContent +=
        'Date,' +
        vm.activeuserbydateSeries[0].name +
        ',' +
        vm.activeuserbydateSeries[1].name +
        '\r\n'

      $.each(vm.activeuserbydateSeries[0].data, function(index, seriesData) {
        csvContent +=
          moment(seriesData[0]).format('DD/MM/YYYY') +
          ',"' +
          numeral(vm.activeuserbydateSeries[0].data[index][1]).format('0,0') +
          '","' +
          numeral(vm.activeuserbydateSeries[1].data[index][1]).format('0,0') +
          '"\r\n'
      })
      csvContent += '\r\n'
      csvContent += 'Messages by Time\r\n'
      csvContent += 'Time,Messages\r\n'

      $.each(vm.activeuserbytimeSeries[0].data, function(index, seriesData) {
        csvContent += index + ':00' + ',"' + numeral(seriesData).format('0,0') + '"\r\n'
      })

      vm.exportCsv(csvContent, 'crm')
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/dashboard/ActiveUserGraph.vue